export const MessageTemplateActionTypes = {
  ADD_MESSAGE: 'ADD_TEMPLATE',
  REMOVE_TEMPLATE: 'REMOVE_TEMPLATE',
};
